export const DEFAULT_ERROR_MESSAGE =
  'Erro ao processar sua requisição. Tente novamente em alguns minutos';
